// src/components/GoogleButton.tsx
import React from "react";
import { GoogleLogin, GoogleCredentialResponse } from "@react-oauth/google";

const GoogleButton: React.FC<{
  onSuccess: (credential: string) => void;
  text?: "signin_with" | "signup_with" | "continue_with";
}> = ({ onSuccess, text = "signin_with" }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <GoogleLogin
        onSuccess={(resp: GoogleCredentialResponse) => {
          if (resp?.credential) onSuccess(resp.credential);
        }}
        onError={() => {}}
        useOneTap={false}
        text={text}
        width="340"
      />
    </div>
  );
};

export default GoogleButton;